import { Stack, Tooltip, Typography } from '@mui/material';
import React from 'react';

import { tableTypes } from '@/shared/components';
import { globalUtils } from '@/shared/duck';
import { muiPalette } from '@/shared/general-theme';

import { StyledTableCell } from '../../ui-table-cell.styled.ts';
import { ToLinkOrNotToLink } from '../link-or-not';

interface CustomCellProp<DataItem> {
  dataItem: DataItem;
  column: tableTypes.ColumnProps<DataItem>;
  cellValue: any;
  description?: string;
  Icon?: React.ReactNode;
}

const UICustomTableCell = <DataItem, >({
  dataItem,
  column,
  cellValue,
  description,
  Icon,
}: CustomCellProp<DataItem>) => {
  return (
    <StyledTableCell
      width={column.width}
      minWidth={column.cellInfo?.hasUnbreakableTextData ? '15rem' : column.minWidth}
      align={column.cellInfo?.alignItems || 'left'}
      sx={{
        wordBreak: column.cellInfo?.hasUnbreakableTextData ? 'break-word' : '',
      }}
    >

      <ToLinkOrNotToLink href={column.cellInfo?.href?.(dataItem) || ''}>
        <Tooltip
          arrow
          title={column.cellInfo?.cellTooltipText || ''}
          placement={column.cellInfo?.cellTooltipPlace || 'bottom'}
        >
          <Stack
            alignItems='center'
            flexDirection='row'
            justifyContent={column.cellInfo?.alignItems || 'left'}
          >

            {Icon}

            <Stack gap='0.13rem' width={column.cellInfo?.fullWidth ? '100%' : 'inherit'}>
              {column.customCellRenderer && column.customCellRenderer(cellValue, dataItem)}

              {description && (
                <Typography
                  variant={'caption'}
                  color={muiPalette.text?.secondary}
                >
                  {globalUtils.sliceTextByLimit(description, true)}
                </Typography>
              )}
            </Stack>
          </Stack>
        </Tooltip>
      </ToLinkOrNotToLink>

    </StyledTableCell>
  );
};

export default UICustomTableCell;